/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { _ as __assign } from '../../tslib.es6-e01eabb2.js';
import { Z as index$y } from '../../index-e5fa4dec.js';
import { extend } from '../extend/index.js';
import setStorage from './panguMiniApp/index.js';
import '../env/index.js';
import '../../index-f24a9ec1.js';
import '../../index-892d8eee.js';
import '../extend/register/index.js';
import '../../bridges/dd/index.js';
import '../../index-6f6b9acc.js';
import '../../_commonjsHelpers-56d33373.js';
import '../../loadscripts-cf212b8d.js';
import '../../constants-163bd007.js';
import '../../bridge-adpter-api-0316c034.js';
import '../../bridges/windvane/index.js';
import '../../bridges/nebula/index.js';
import '../../index.es-142c5680.js';
import '../../bridges/pangu-mini-app/index.js';
import '../../log-aabf3a34.js';

var apiConfig = {
    web: {
        panguMiniApp: setStorage,
    },
};
var extendRemoveStorage = extend(apiConfig, index$y);
/**
 * 设置缓存。API：https://yuque.antfin.com/cn-xt/arch/lwbvd0
 * @returns {Promise<unknown>} promise调用结果
 *
 * @example
 * import { removeStorage } from '@alife/cn-uni-api';
 *
 * removeStorage('your-key')
 * .then((res) => {
 *   console.log('success', res);
 * })
 * .catch((error) => {
 *   console.log(error);
 * });
 * @author 敬文
 */
var removeStorage = function (key, params) {
    if (typeof key === 'string') {
        return extendRemoveStorage(__assign(__assign({}, params), { key: key }));
    }
    return extendRemoveStorage(key);
};

export { extendRemoveStorage, removeStorage };
